var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaused = function SvgPaused(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h32v32H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 19.333c.734 0 1.334-.6 1.334-1.333v-8c0-.733-.6-1.333-1.334-1.333C10.6 8.667 10 9.267 10 10v8c0 .733.6 1.333 1.333 1.333zM14 .667C6.64.667.667 6.64.667 14S6.64 27.333 14 27.333 27.333 21.36 27.333 14 21.36.667 14 .667zm0 24C8.12 24.667 3.333 19.88 3.333 14S8.12 3.333 14 3.333 24.667 8.12 24.667 14 19.88 24.667 14 24.667zm2.667-5.334c.733 0 1.333-.6 1.333-1.333v-8c0-.733-.6-1.333-1.333-1.333-.734 0-1.334.6-1.334 1.333v8c0 .733.6 1.333 1.334 1.333z",
    fill: "#1D1D1D",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaused, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paused.1b2db131.svg";
export { ForwardRef as ReactComponent };